import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useReloadEntityField, useUrlQueryUid2Field } from 'components/form'
import DefaultEntityCrud from 'components/form/DefaultEntityCrud';
import EntitySearchInput from 'components/form/EntitySearch/EntitySearchInput';
import FormContent from 'components/form/FormContent';
import FormRow from 'components/form/FormRow';
import AutocompleteInput from 'components/form/input/AutocompleteInput';
import SelectInput from 'components/form/input/SelectInput';
import TextInput from 'components/form/input/TextInput';
import DebugObjComp from 'components/DebugObjComp'
import SeletorHorarioReuniao from '../SeletorHorarioReuniao';
import PainelAgendaReuniao from '../PainelAgendaReuniao'

import InscricaoEntity from 'entity/Inscricao';
import ReuniaoEntity from 'entity/Reuniao';
import RodadaEntity from 'entity/Rodada';
import { getReunioes, useAllAtiveReunioes } from 'entity/Reuniao/funtions';


import { formatHorarioString } from 'util/string'

import { Button } from '@mui/material'
import { KeyboardReturn } from '@mui/icons-material'
import useNotification from 'notification'
// import { useAppContext } from 'app/AppContext';

function ReuniaoFormInter(props) {
    const { showWarning } = useNotification()
    const { change } = props.form

    const navigate = useNavigate()

    const { uid, rodada, mesa, inscricao1, inscricao2, horario } = props.values
    const reunioesMesa = useAllAtiveReunioes(rodada, mesa)
    const [reunioesP1, setReunioesP1] = useState([])
    const [reunioesP2, setReunioesP2] = useState([])
    const [searchParams] = useSearchParams()
    const searchUid = searchParams.get("uid")

    useUrlQueryUid2Field('rodada', 'rodada', RodadaEntity, props.form)
    useReloadEntityField(RodadaEntity, 'rodada', props, (r) => {
        let mesas = r.mesas;
        if (mesa && mesas) {
            let indexOf = mesas.map(m => m.uid).indexOf(mesa.uid)
            if (indexOf !== -1) {
                change("mesa", mesas[indexOf])
            } else {
                change("mesa", null)
            }
        }
    })

    useEffect(() => {
        if (inscricao2) {
            getReunioes(inscricao2.uid).then(r => {
                if (inscricao1) {

                    let find = r.find(ri => ri.inscricao1.uid === inscricao1.uid || ri.inscricao2.uid === inscricao1.uid)

                    // só tá editando a reunião já marcada
                    if (searchUid === find.uid) {
                        find = false
                    }

                    if (find) {

                        showWarning(inscricao2.empresa.nomeFantasia + " já possui reunião agendada com esta empresa: " + find.mesa.name + " - " + find.horariotxt)
                        change("inscricao2", null)
                        setReunioesP2([])
                    } else {
                        setReunioesP2(r)
                    }
                } else {
                    setReunioesP2(r)
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inscricao2])

    useEffect(() => {
        if (inscricao1) {
            getReunioes(inscricao1.uid).then(r => {


                if (inscricao2) {

                    let find = r.find(ri => ri.inscricao1.uid === inscricao2.uid || ri.inscricao2.uid === inscricao2.uid)

                    if (searchUid === find.uid) {
                        find = false
                    }

                    if (find) {

                        showWarning(inscricao1.empresa.nomeFantasia + " já possui reunião agendada com esta empresa: " + find.mesa.name + " - " + find.horariotxt)
                        change("inscricao1", null)
                        setReunioesP1([])
                    } else {
                        setReunioesP1(r)
                    }
                } else {
                    setReunioesP1(r)
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inscricao1])

    // useEffect(() => {
    //     if (inscricao1) {
    //         if (inscricao1.tipo === "ÂNCORA") {
    //             if (inscricao1.mesa) {

    //                 change('mesa', inscricao1.mesa)
    //             }
    //         }
    //     }
    // }, [inscricao1, change])

    useEffect(() => {

        if (inscricao1) {
            if (inscricao1.tipo === "ÂNCORA") {
                if (inscricao1.mesa) {
                    let auxM = props.values.rodada?.mesas.find((m) => m.uid === inscricao1.mesa.uid)
                    // console.log('auxM',auxM)
                    change("mesa", auxM)
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [change, inscricao1])

    const queryP1 = (query) => {
        query = query.where("rodada.uid", "==", rodada.uid)
        if (inscricao2)
            query = query.where("uid", "!=", inscricao2.uid)
        return query;
    }
    const queryP2 = (query) => {
        query = query.where("rodada.uid", "==", rodada.uid)
        if (inscricao1)
            query = query.where("uid", "!=", inscricao1.uid)
        return query;
    }
    const query = (query) => {
        query = query.where("status", "==", "ATIVO")
        return query;
    }

    const selectHorario = (horario) => {
        change("horario", horario)
        change("horariotxt", formatHorarioString(horario.horario))
    }

    return (
        <>
            {rodada &&
                <Button
                    startIcon={<KeyboardReturn />}
                    variant='contained'
                    color='primary'
                    onClick={() => {
                        navigate(`/painel-controle?rodada=${rodada.uid}`)
                    }}
                >
                    Ir para o painel de controle
                </Button>
            }
            <FormContent sx={{ m: 1 }}>
                <FormRow>
                    <SelectInput
                        sx={{ flex: 0.5 }}
                        name="status"
                        label="Status"
                        options={["ATIVO", "INATIVO"]}
                        required
                    />
                    <EntitySearchInput
                        name="rodada"
                        label="Rodada"
                        EntityClass={RodadaEntity}
                        extraQuery={query}
                        disabled={rodada ? true : false}
                        required
                    />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="inscricao1"
                        label="Participante 1"
                        EntityClass={InscricaoEntity}
                        extraQuery={queryP1}
                        specificColumns={[
                            { field: "empresa.nomeEmpresaCracha", headerName: "NOME DA EMPRESA", flex: 2, filter: true },
                            { field: "tipo", headerName: "TIPO DE INSCRIÇÃO", flex: 0.65, filter: true },
                        ]}
                        addFields={["tipo"]}
                        disabled={rodada ? false : true}
                        required
                    />
                    <AutocompleteInput
                        name="mesa"
                        label="Mesa"
                        disabled={!rodada}
                        options={rodada?.mesas || []}
                        required
                        getOptionLabel={(option) => option.name}
                        isOptionEqualToValue={(option, value) => option.uid === value.uid}
                    />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="inscricao2"
                        label="Participante 2"
                        EntityClass={InscricaoEntity}
                        extraQuery={queryP2}
                        specificColumns={[
                            { field: "empresa.nomeEmpresaCracha", headerName: "NOME DA EMPRESA", flex: 2, filter: true },
                            { field: "tipo", headerName: "TIPO DE INSCRIÇÃO", flex: 0.65, filter: true },
                        ]}
                        addFields={["tipo"]}
                        disabled={rodada ? false : true}
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput name="obs" label="Obs" multiline />
                </FormRow>
                <FormRow>
                    <SeletorHorarioReuniao uidReuniao={uid} rodada={rodada} mesa={mesa} />
                </FormRow>
                <FormRow>
                    {(rodada && mesa)
                        &&
                        <PainelAgendaReuniao
                            rodada={rodada}
                            onClick={selectHorario}
                            atualValue={horario}
                            reuniaoAtual={props.values}
                            reunioes={(reunioesMesa || []).concat(reunioesP2).concat(reunioesP1 || [])}
                            mesa={mesa}
                        />
                    }

                </FormRow>
                <DebugObjComp colection={ReuniaoEntity.collectionUID} uidObj={props.values.uid} values={props.values} />
            </FormContent>
        </>
    )
}

export default function ReuniaoForm() {
    return (
        <DefaultEntityCrud
            EntityClass={ReuniaoEntity}
            title={"Cadastro de Reunião"}
            routeForm="reuniao"
            backRoute="consultareuniao"
            formActions={{ /*novoForm: true,*/ salvarForm: true/*, sairForm: true*/ }}
        >
            {(props) => {
                return <ReuniaoFormInter {...props} />
            }}
        </DefaultEntityCrud>
    )
}